import React, { useState, useEffect } from 'react';
import useStore from '../store';
import { fetchAllWatchlists, fetchWatchlistStocks } from '../api';

function WatchlistPanel() {
  const { watchlist, selectedSymbol, setSelectedSymbol, setWatchlist } = useStore();
  const [collapsed,   setCollapsed]   = useState(false);
  const [watchlists,  setWatchlists]  = useState([]);
  const [selectedWL,  setSelectedWL]  = useState('');

  useEffect(() => {
    fetchAllWatchlists()
      .then(data => setWatchlists(data || []))
      .catch(console.error);
  }, []);

  const handleWatchlistChange = async (wlId) => {
    setSelectedWL(wlId);
    if (!wlId) return;
    try {
      const stocks  = await fetchWatchlistStocks(wlId);
      const symbols = (stocks || []).map(s => s.symbol);
      if (symbols.length > 0) {
        setWatchlist(symbols);
        setSelectedSymbol(symbols[0]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div style={styles.wrapper(collapsed)}>

      {/* Toggle arrow */}
      <button
        style={styles.toggleBtn}
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? 'Expand watchlist' : 'Collapse watchlist'}
      >
        {collapsed ? '›' : '‹'}
      </button>

      {!collapsed && (
        <div style={styles.list}>

          {/* Watchlist selector */}
          <select
            style={styles.selector}
            value={selectedWL}
            onChange={e => handleWatchlistChange(e.target.value)}
          >
            <option value="">WATCHLIST</option>
            {watchlists.map(wl => (
              <option key={wl.id} value={wl.id}>{wl.name}</option>
            ))}
          </select>

          {/* Symbol list */}
          {watchlist.map((sym) => (
            <div
              key={sym}
              style={{
                ...styles.item,
                ...(sym === selectedSymbol ? styles.itemActive : {}),
              }}
              onClick={() => setSelectedSymbol(sym)}
              title={sym}
            >
              {sym}
            </div>
          ))}
        </div>
      )}

    </div>
  );
}

const styles = {
  wrapper: (collapsed) => ({
    position:        'relative',
    width:           collapsed ? '18px' : '110px',
    minWidth:        collapsed ? '18px' : '110px',
    height:          '100%',
    backgroundColor: '#fafafa',
    borderRight:     '1px solid #e0e0e0',
    display:         'flex',
    flexDirection:   'column',
    transition:      'width 0.2s ease, min-width 0.2s ease',
    flexShrink:      0,
    overflow:        'hidden',
    zIndex:          10,
  }),
  toggleBtn: {
    position:        'absolute',
    right:           '-1px',
    top:             '50%',
    transform:       'translateY(-50%)',
    width:           '16px',
    height:          '40px',
    backgroundColor: '#e8f0fe',
    border:          '1px solid #c5d0e8',
    borderLeft:      'none',
    borderRadius:    '0 4px 4px 0',
    cursor:          'pointer',
    fontSize:        '12px',
    color:           '#2962ff',
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    zIndex:          11,
    padding:         0,
  },
  selector: {
    width:        '100%',
    padding:      '4px 2px',
    fontSize:     '9px',
    border:       'none',
    borderBottom: '1px solid #eee',
    background:   '#fafafa',
    color:        '#999',
    fontWeight:   'bold',
    cursor:       'pointer',
    outline:      'none',
    textTransform:'uppercase',
    letterSpacing:'0.5px',
  },
  list: {
    flex:      1,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: '0',
  },
  item: {
    padding:      '6px 8px',
    fontSize:     '12px',
    color:        '#333',
    cursor:       'pointer',
    whiteSpace:   'nowrap',
    overflow:     'hidden',
    textOverflow: 'ellipsis',
    borderRadius: '0',
    userSelect:   'none',
  },
  itemActive: {
    backgroundColor: '#e8f0fe',
    color:           '#2962ff',
    fontWeight:      'bold',
  },
};

export default WatchlistPanel;